<template>
  <div class="merchant-detail">
     <div class="card card-custom">
        <div class="card-header card-tabs-header">
          <!-- <div class="card-title">
            <h3 class="card-label">Create a Payment Link</h3>
          </div> -->
          <v-tabs v-model="merchantTab">
            <v-tab href="#profile">Profile</v-tab>
            <v-tab href="#user">Users</v-tab>
            <v-tab href="#payment">Payment Mode</v-tab>
            <v-tab href="#paymentForm">Payment Form</v-tab>
          </v-tabs>
        </div>
        <div class="card-body pt-5">
          <div class="merchant-tab-body">
            <v-tabs-items v-model="merchantTab">
              <v-tab-item value="profile">
                <merchant-profile />
              </v-tab-item>
              <v-tab-item value="user">
                <merchant-users />
              </v-tab-item>
              <v-tab-item value="payment">
                <payment-mode />
              </v-tab-item>
               <v-tab-item value="paymentForm">
                <payment-form />
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
     </div>
  </div>
</template>
<script>
import MerchantProfile from './components/MerchantProfile.vue';
import MerchantUsers from './components/MerchantUsers.vue';
import PaymentMode from './components/payment-mode/PaymentMode.vue';
import PaymentForm from './PaymentFrom/payment-form.vue';

export default {
  components: { MerchantProfile, MerchantUsers, PaymentMode, PaymentForm },
  name: "MerchantDetail",
  data () {
    return {
      merchantTab: null,
    }
  }
 
};
</script>
